<template>
    <div id="dialog" class="dialog-size">
      <table id="table-layout" border="0">
        <tr>
          <td id="table-td-title">
            <!-- HEADER -->
          <h>{{ $t("c19confirm.header") }}</h>
          </td>
        </tr>
        <tr>
          <td id="table-td-icon">
            <img src="../../../assets/images/confirm-icon.png" width="50px" style="vertical-align:middle">
            <!-- TITLE -->
            {{ $t("c19confirm.title") }}
          </td>
        <tr>
        <tr>
          <td class="table-td-statement" >
            <!-- STATEMENT -->
            {{ $t("c19confirm.statement") }}
          </td>
        </tr>
        <tr>
          <td class="table-td-message" style="font-size:14px">
            <!--<p>{{ this.text }}</p>-->
            <div style="height:150px;overflow-y:auto">
            <li v-for="item in this.text" :key="item">
              {{ item }}
            </li>
            </div>
          </td>
        </tr>
        
        <tr>
          <td id="table-td-command">
            <!-- CORRECT -->
            
            <input type="button" class="command" v-on:click.capture="yes()" v-bind:value="$t('c19confirm.correct')">
            &nbsp;
            <!-- CANCEL -->
            <input type="button" class="command" v-on:click.capture="no()" v-bind:value="$t('c19confirm.cancel')">
            
          </td>
        </tr>
        
      </table>
    </div>
   
</template>

<script>
  

  export default {
      name: 'c19-confirm-box',
      props: ['text', 'func', 'returnResult'],
      methods:
      {
        no()
        { 
          this.$emit('close');
         
          if(this.func != undefined)
          { 
            // EXTERNAL FUCTION POINTER
            this.func(0);
          }
        },
        yes()
        { 
          this.$emit('close');
         
          if(this.func != undefined)
          { 
            // EXTERNAL FUCTION POINTER
            this.func(1);
          }
        }
      },
    mounted () {
      // SHOW TOP OF VIEW
      window.scrollTo(0, 0);
    }
  }
</script>

<style lang="scss" scoped>

// DISABLE WIDESCREEN BREAKPOINT
$widescreen-enabled: false;

// DISABLE FULLHD BREAKPOINT
$fullhd-enabled: false;

//////////////////////////////////////////
// MOBILE
@media only screen and 
(min-width : 320px) and (max-width : 1023px)
{
  div.dialog-size {
    margin: auto;
    width:100%;
    height:100%;
  }
  #table-layout
  {
    width:100%;
    height:100%;
  }
  #table-td-title
  {
    color:white;
    text-align:center;
    background-color: #343F68;
  }
  #table-td-icon
  {
    color:black;
    display: inline-block;
    padding-left: 10px;
    vertical-align:middle;
    border-bottom:1px solid black;
    width: 100%;
    background-color: #F0F0F0;//#4682B4;
    padding-top:5px;
    padding-bottom: 5px;
    //font-weight: 500;
    font-family: Lato; 
    font-size: 16px; 
    font-style: normal; 
    font-variant: small-caps; 
    font-weight: 500; 
  }
  .table-td-statement
  {
    color:black;
    vertical-align:top;
    text-align:left;
    background-color: #F0F0F0;//#4682B4;
    padding-left: 5px;
  }
  .table-td-message
  {
    color:black;
    height: 100%;
    vertical-align:top;
    text-align:left;
    background-color: #F0F0F0;//#4682B4;
    padding-top: 10px;
    padding-left: 5px;
  }
  #table-td-command
  {
    color:black;
    vertical-align:bottom;
    text-align:center;
    background-color: #F0F0F0;//#4682B4;
    padding-bottom: 10px;
    padding-top:5px;
  }
  .command
  {
    border-radius:15px;
    background-color:#343F68;
    color:white;
    font-size: 15px;
  }
}


//////////////////////////////////////////
// DESKTOP
@media screen and (min-width:1024px)  
{
  div.dialog-size {
    margin: auto;
    width:100%;
    height:100%;
  }
  #table-layout
  {
    width:100%;
    height:100%;
  }
  #table-td-title
  {
    color:white;
    text-align:center;
    background-color: #343F68;
  }
  #table-td-icon
  {
    color:black;
    display: inline-block;
    padding-left: 10px;
    vertical-align:middle;
    border-bottom:1px solid black;
    width: 100%;
    background-color: #F0F0F0;//#4682B4;
    padding-top:5px;
    padding-bottom: 5px;
    //font-weight: 500;
    font-family: Lato; 
    font-size: 16px; 
    font-style: normal; 
    font-variant: small-caps; 
    font-weight: 500; 
  }
  .table-td-statement
  {
    color:black;
    vertical-align:top;
    text-align:left;
    background-color: #F0F0F0;//#4682B4;
    padding-left: 5px;
  }
  .table-td-message
  {
    color:black;
    height: 100%;
    vertical-align:top;
    text-align:left;
    background-color: #F0F0F0;//#4682B4;
    padding-top: 10px;
    padding-left: 5px;
  }
  #table-td-command
  {
    color:black;
    vertical-align:bottom;
    text-align:center;
    background-color: #F0F0F0;//#4682B4;
    padding-bottom: 10px;
  }
  .command
  {
    border-radius:15px;
    background-color:#343F68;
    color:white;
    font-size: 15px;
  }
}
</style>